(function () {
  'use strict';

  // ─── ANNOUNCEMENT BAR ───────────────────────────────────────────────────────

  function initAnnouncementBar() {
    var announcementBar = document.getElementById('announcementBar');
    var closeBtn = document.getElementById('announcementBarClose');

    if (!announcementBar || !closeBtn) return;

    if (sessionStorage.getItem('taik-announcement-dismissed')) {
      announcementBar.style.display = 'none';
      return;
    }

    function hideAnnouncement() {
      announcementBar.classList.add('announcement-bar--hidden');
      sessionStorage.setItem('taik-announcement-dismissed', '1');
      setTimeout(function () {
        announcementBar.style.display = 'none';
      }, 300);
    }

    closeBtn.addEventListener('click', hideAnnouncement);

    announcementBar.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        hideAnnouncement();
      }
    });
  }

  // ─── MOBILE MENU ────────────────────────────────────────────────────────────

  function initMobileMenu() {
    var hamburgerBtn = document.querySelector('.header__hamburger');
    var mobileMenu = document.querySelector('.mobile-menu');
    var closeBtn = document.querySelector('.mobile-menu__close');
    var body = document.body;
    var expandableItems = document.querySelectorAll('.mobile-menu__nav-item--expandable');

    if (!hamburgerBtn || !mobileMenu) return;

    function openMenu() {
      mobileMenu.classList.add('mobile-menu--open');
      body.classList.add('menu-open');
      if (closeBtn) closeBtn.focus();
    }

    function closeMenu() {
      mobileMenu.classList.remove('mobile-menu--open');
      body.classList.remove('menu-open');
      if (hamburgerBtn) hamburgerBtn.focus();
    }

    function toggleMenu() {
      if (mobileMenu.classList.contains('mobile-menu--open')) {
        closeMenu();
      } else {
        openMenu();
      }
    }

    function toggleSubmenu(item) {
      var isExpanded = item.classList.contains('is-expanded');
      expandableItems.forEach(function (expandableItem) {
        if (expandableItem !== item) {
          expandableItem.classList.remove('is-expanded');
        }
      });
      if (isExpanded) {
        item.classList.remove('is-expanded');
      } else {
        item.classList.add('is-expanded');
      }
    }

    hamburgerBtn.addEventListener('click', openMenu);

    if (closeBtn) {
      closeBtn.addEventListener('click', closeMenu);
    }

    mobileMenu.addEventListener('click', function (e) {
      if (e.target === mobileMenu) {
        closeMenu();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileMenu.classList.contains('mobile-menu--open')) {
        closeMenu();
      }
    });

    expandableItems.forEach(function (item) {
      var link = item.querySelector('.mobile-menu__nav-link');
      if (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          toggleSubmenu(item);
        });
      }
    });

    // iOS scroll fix via MutationObserver
    var scrollPosition = 0;

    var preventScroll = function () {
      scrollPosition = window.pageYOffset;
      body.style.overflow = 'hidden';
      body.style.position = 'fixed';
      body.style.top = '-' + scrollPosition + 'px';
      body.style.width = '100%';
    };

    var allowScroll = function () {
      body.style.removeProperty('overflow');
      body.style.removeProperty('position');
      body.style.removeProperty('top');
      body.style.removeProperty('width');
      window.scrollTo(0, scrollPosition);
    };

    var menuObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === 'class') {
          if (body.classList.contains('menu-open')) {
            preventScroll();
          } else {
            allowScroll();
          }
        }
      });
    });

    menuObserver.observe(body, { attributes: true });
  }

  // ─── DESKTOP DROPDOWN / MEGA MENU ───────────────────────────────────────────

  function initDropdowns() {
    var dropdownItems = document.querySelectorAll('.nav__item--has-dropdown, .nav__item--has-megamenu');
    var currentlyOpen = null;

    function openDropdown(item) {
      if (currentlyOpen && currentlyOpen !== item) {
        closeDropdown(currentlyOpen);
      }
      item.classList.add('is-open');
      currentlyOpen = item;
      var link = item.querySelector('.nav__link');
      if (link) link.setAttribute('aria-expanded', 'true');
    }

    function closeDropdown(item) {
      item.classList.remove('is-open');
      if (currentlyOpen === item) currentlyOpen = null;
      var link = item.querySelector('.nav__link');
      if (link) link.setAttribute('aria-expanded', 'false');
    }

    function toggleDropdown(item) {
      if (item.classList.contains('is-open')) {
        closeDropdown(item);
      } else {
        openDropdown(item);
      }
    }

    dropdownItems.forEach(function (item) {
      var link = item.querySelector('.nav__link');
      var dropdown = item.querySelector('.nav__dropdown') || item.querySelector('.nav__megamenu');

      if (!link || !dropdown) return;

      link.setAttribute('aria-haspopup', 'true');
      link.setAttribute('aria-expanded', 'false');

      item.addEventListener('mouseenter', function () {
        openDropdown(item);
      });

      item.addEventListener('mouseleave', function () {
        closeDropdown(item);
      });

      link.addEventListener('click', function (e) {
        var isMobile = window.innerWidth < 1024;
        if (!isMobile) {
          window.location.href = '/collections/all';
          return;
        }
        e.preventDefault();
        toggleDropdown(item);
      });

      link.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleDropdown(item);
        }
        if (e.key === 'Escape') {
          closeDropdown(item);
          link.focus();
        }
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          openDropdown(item);
          var firstDropdownLink = dropdown.querySelector('.nav__dropdown-link') || dropdown.querySelector('.nav__megamenu-card');
          if (firstDropdownLink) firstDropdownLink.focus();
        }
      });

      var dropdownLinks = item.classList.contains('nav__item--has-megamenu')
        ? dropdown.querySelectorAll('.nav__megamenu-card')
        : dropdown.querySelectorAll('.nav__dropdown-link');

      dropdownLinks.forEach(function (dropdownLink, index) {
        dropdownLink.addEventListener('keydown', function (e) {
          var isMegaMenu = item.classList.contains('nav__item--has-megamenu');

          if (e.key === 'ArrowDown' || (isMegaMenu && e.key === 'ArrowRight')) {
            e.preventDefault();
            var nextLink = dropdownLinks[index + 1];
            if (nextLink) {
              nextLink.focus();
            } else {
              dropdownLinks[0].focus();
            }
          }

          if (e.key === 'ArrowUp' || (isMegaMenu && e.key === 'ArrowLeft')) {
            e.preventDefault();
            var prevLink = dropdownLinks[index - 1];
            if (prevLink) {
              prevLink.focus();
            } else {
              dropdownLinks[dropdownLinks.length - 1].focus();
            }
          }

          if (e.key === 'Escape') {
            e.preventDefault();
            closeDropdown(item);
            link.focus();
          }

          if (e.key === 'Tab' && !e.shiftKey && index === dropdownLinks.length - 1) {
            closeDropdown(item);
          }
        });
      });
    });

    document.addEventListener('click', function (e) {
      var isDropdownElement = e.target.closest('.nav__item--has-dropdown, .nav__item--has-megamenu');
      if (!isDropdownElement && currentlyOpen) {
        closeDropdown(currentlyOpen);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && currentlyOpen) {
        var focusLink = currentlyOpen.querySelector('.nav__link');
        closeDropdown(currentlyOpen);
        if (focusLink) focusLink.focus();
      }
    });
  }

  // ─── SHOPPING CART ──────────────────────────────────────────────────────────

  var cartPanel, cartButton, cartCloseButton, cartOverlay, continueButton;
  var FREE_SHIPPING_THRESHOLD = 9900; // $99.00 in cents

  function formatMoney(cents) {
    var format = (window.taik && window.taik.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var amountNoDecimals = String(Math.round(cents / 100));
    var amountWithCommaPeriod = parseFloat(amount).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var amountNoDecimalsWithSpaces = amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return format
      .replace('{{amount_with_comma_separator}}', amountWithCommaPeriod)
      .replace('{{amount_no_decimals_with_space_separator}}', amountNoDecimalsWithSpaces)
      .replace('{{amount_no_decimals}}', amountNoDecimals)
      .replace('{{amount}}', amount);
  }

  function buildShippingBarHTML(totalPrice) {
    var remaining = FREE_SHIPPING_THRESHOLD - totalPrice;
    var percent = Math.min(100, (totalPrice / FREE_SHIPPING_THRESHOLD) * 100);
    if (remaining <= 0) {
      return '<div class="shipping-bar shipping-bar--free">'
        + '<p class="shipping-bar__message">You\'ve qualified for <strong>FREE</strong> shipping!</p>'
        + '<div class="shipping-bar__track"><div class="shipping-bar__fill" style="width:100%"></div></div>'
        + '</div>';
    }
    return '<div class="shipping-bar">'
      + '<p class="shipping-bar__message">You\'re <strong>' + formatMoney(remaining) + '</strong> away from free shipping!</p>'
      + '<div class="shipping-bar__track"><div class="shipping-bar__fill" style="width:' + percent + '%"></div></div>'
      + '</div>';
  }

  function fetchCart() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    }).then(function (res) {
      return res.json();
    });
  }

  function buildCartItemsHTML(items) {
    if (items.length === 0) return '';
    var html = '<ul class="shopping-cart__items">';
    items.forEach(function (item, index) {
      var lineIndex = index + 1;
      var imgSrc = item.image ? item.image : '';
      var itemUrl = item.url || '';
      html += '<li class="cart-item">';
      html += '<a href="' + itemUrl + '" class="cart-item__image-link"><img class="cart-item__image" src="' + imgSrc + '" alt="' + (item.title || '').replace(/"/g, '&quot;') + '" width="121" loading="lazy"></a>';
      html += '<div class="cart-item__details">';
      html += '<button class="cart-item__button cart-item__button--remove" data-action="remove" data-line="' + lineIndex + '" aria-label="Remove from cart">';
      html += '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="4" y1="4" x2="12" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="12" y1="4" x2="4" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
      html += '</button>';
      html += '<span class="cart-item__category">' + (item.product_type || '').toUpperCase() + '</span>';
      html += '<div class="cart-item__meta">';
      html += '<h3 class="cart-item__name"><a href="' + itemUrl + '" class="cart-item__name-link">' + (item.title || '') + '</a></h3>';
      html += '<span class="cart-item__price">' + formatMoney(item.line_price) + '</span>';
      html += '</div>';
     if ((item.title || '').toLowerCase().indexOf('coffee') > -1 || (item.title || '').toLowerCase().indexOf('bundle') > -1) {
  html += '<p class="cart-item__preorder">Pre-order item. Expected dispatch: August 2026.</p>';
}
      if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
        html += '<span class="cart-item__plan">' + item.selling_plan_allocation.selling_plan.name + '</span>';
      }
      if (item.properties) {
        Object.keys(item.properties).forEach(function (key) {
          var val = item.properties[key];
          if (key === 'Addressee' || !val || key.charAt(0) === '_') return;
          html += '<span class="cart-item__property"><strong>' + key + ':</strong> ' + val + '</span>';
        });
      }
      if (item.variant_title === 'Signed Hardcover') {
        var addresseeVal = (item.properties && item.properties['Addressee']) || '';
        html += '<div class="cart-item__addressee">';
        html += '<label class="cart-item__addressee-label" for="addressee-' + lineIndex + '">Sign to:</label>';
        html += '<input type="text" id="addressee-' + lineIndex + '" class="cart-item__addressee-input" data-line="' + lineIndex + '" value="' + addresseeVal.replace(/"/g, '&quot;') + '" placeholder="Enter a name (optional)" aria-label="Who should the book be signed to?">';
        html += '</div>';
      }
      html += '</div>';
      html += '<div class="cart-item__controls">';
      html += '<span class="cart-item__qty-label">QTY</span>';
      html += '<button class="cart-item__button" data-action="decrease" data-line="' + lineIndex + '" aria-label="Decrease quantity">';
      html += '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="4" y1="8" x2="12" y2="8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
      html += '</button>';
      html += '<input type="number" class="cart-item__quantity" value="' + item.quantity + '" min="1" max="99" data-line="' + lineIndex + '" aria-label="Quantity">';
      html += '<button class="cart-item__button" data-action="increase" data-line="' + lineIndex + '" aria-label="Increase quantity">';
      html += '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="8" y1="4" x2="8" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="4" y1="8" x2="12" y2="8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
      html += '</button>';
      html += '</div></li>';
    });
    html += '</ul>';
    return html;
  }

  function updateCartCount(count) {
    var cartCountEls = document.querySelectorAll('[data-cart-count]');
    cartCountEls.forEach(function (el) {
      el.textContent = '(' + count + ')';
    });
  }

  function renderCartItems(cart) {
    var totalValue = document.querySelector('.shopping-cart__total-value');
    var cartContent = document.querySelector('.shopping-cart__content');

    if (totalValue) {
      totalValue.textContent = formatMoney(cart.total_price);
    }

    var shippingBar = document.querySelector('#shoppingCart .shipping-bar-wrapper');
    if (shippingBar) {
      shippingBar.innerHTML = cart.item_count > 0 ? buildShippingBarHTML(cart.total_price) : '';
    }

    updateCartCount(cart.item_count);

    if (!cartContent) return;

    if (cart.item_count === 0) {
      cartContent.innerHTML = '<p class="shopping-cart__empty">Your cart is empty.</p>';
      return;
    }

    cartContent.innerHTML = buildCartItemsHTML(cart.items);
    attachCartItemListeners();
  }

  function changeCartLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (res) {
      return res.json();
    }).then(function (cart) {
      renderCartItems(cart);
    });
  }

  function saveAddresseeProperty(line, value, renderFn) {
    return fetchCart().then(function (cart) {
      var item = cart.items[line - 1];
      if (!item) return;
      var props = {};
      if (item.properties) {
        Object.keys(item.properties).forEach(function (k) { props[k] = item.properties[k]; });
      }
      props['Addressee'] = value;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: item.quantity, properties: props })
      }).then(function (res) { return res.json(); });
    }).then(function (cart) {
      if (cart && renderFn) renderFn(cart);
    });
  }

  function attachCartItemListeners() {
    var drawerPanel = document.getElementById('shoppingCart');
    if (!drawerPanel) return;

    var buttons = drawerPanel.querySelectorAll('.cart-item__button');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = parseInt(btn.getAttribute('data-line'), 10);
        var action = btn.getAttribute('data-action');
        var input = drawerPanel.querySelector('.cart-item__quantity[data-line="' + line + '"]');
        var currentQty = input ? parseInt(input.value, 10) : 1;
        var newQty;
        if (action === 'remove') {
          newQty = 0;
        } else if (action === 'increase') {
          newQty = currentQty + 1;
        } else {
          newQty = Math.max(0, currentQty - 1);
        }
        changeCartLine(line, newQty);
      });
    });

    var quantityInputs = drawerPanel.querySelectorAll('.cart-item__quantity');
    quantityInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var line = parseInt(input.getAttribute('data-line'), 10);
        var newQty = Math.max(0, parseInt(input.value, 10) || 0);
        changeCartLine(line, newQty);
      });
    });

    var addresseeInputs = drawerPanel.querySelectorAll('.cart-item__addressee-input');
    addresseeInputs.forEach(function (input) {
      input.addEventListener('blur', function () {
        var line = parseInt(input.getAttribute('data-line'), 10);
        saveAddresseeProperty(line, input.value, renderCartItems);
      });
    });
  }

  function openCart() {
    cartPanel = document.getElementById('shoppingCart');
    cartButton = document.querySelector('[data-cart-button]');
    cartCloseButton = cartPanel ? cartPanel.querySelector('.shopping-cart__close') : null;

    if (!cartPanel) return;

    // Open panel immediately
    cartPanel.classList.add('is-open');
    cartPanel.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    var mobileMenu = document.querySelector('.mobile-menu');
    if (mobileMenu && mobileMenu.classList.contains('mobile-menu--open')) {
      mobileMenu.classList.remove('mobile-menu--open');
      document.body.classList.remove('menu-open');
    }

    setTimeout(function () {
      if (cartCloseButton) cartCloseButton.focus();
    }, 100);

    // Show loading state while fetch is in flight
    var cartContent = document.querySelector('.shopping-cart__content');
    if (cartContent) {
      cartContent.innerHTML = '<p class="shopping-cart__loading">Loading...</p>';
    }

    // Populate with real cart data
    fetchCart().then(function (cart) {
      renderCartItems(cart);
    });
  }

  function closeCart() {
    cartPanel = document.getElementById('shoppingCart');
    cartButton = document.querySelector('[data-cart-button]');
    if (!cartPanel) return;
    cartPanel.classList.remove('is-open');
    cartPanel.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (cartButton) cartButton.focus();
  }

  function initCart() {
    cartPanel = document.getElementById('shoppingCart');
    cartButton = document.querySelector('[data-cart-button]');

    if (!cartPanel || !cartButton) return;

    cartCloseButton = cartPanel.querySelector('.shopping-cart__close');
    cartOverlay = cartPanel.querySelector('.shopping-cart__overlay');
    continueButton = cartPanel.querySelector('.shopping-cart__continue');

    cartButton.addEventListener('click', function (e) {
      e.preventDefault();
      openCart();
    });

    if (cartCloseButton) {
      cartCloseButton.addEventListener('click', closeCart);
    }

    if (cartOverlay) {
      cartOverlay.addEventListener('click', closeCart);
    }

    if (continueButton) {
      continueButton.addEventListener('click', closeCart);
    }

    document.addEventListener('keydown', function (e) {
      cartPanel = document.getElementById('shoppingCart');
      if (e.key === 'Escape' && cartPanel && cartPanel.classList.contains('is-open')) {
        closeCart();
      }
    });

    attachCartItemListeners();
  }

  // ─── FAQ / PRODUCT ACCORDION ─────────────────────────────────────────────────

  function initAccordions(root) {
    var scope = root || document;
    var items = scope.querySelectorAll('.faq-accordion__item');

    items.forEach(function (item) {
      var btn = item.querySelector('.faq-accordion__question');
      var answer = item.querySelector('.faq-accordion__answer');
      var icon = item.querySelector('.faq-accordion__icon');

      if (!btn || !answer) return;

      // Skip items that were already initialised
      if (btn.dataset.accordionInit) return;
      btn.dataset.accordionInit = '1';

      btn.addEventListener('click', function () {
        var isExpanded = item.classList.contains('is-expanded');

        if (isExpanded) {
          item.classList.remove('is-expanded');
          btn.setAttribute('aria-expanded', 'false');
          if (icon) icon.textContent = '+';
        } else {
          item.classList.add('is-expanded');
          btn.setAttribute('aria-expanded', 'true');
          if (icon) icon.textContent = '\u2212';
        }
      });
    });
  }

  // ─── PRODUCT GALLERY ─────────────────────────────────────────────────────────

  function initProductGallery(root) {
    var scope = root || document;
    var galleries = scope.querySelectorAll('.product-gallery');

    galleries.forEach(function (gallery) {
      // Prevent double-init
      if (gallery.dataset.galleryInit) return;
      gallery.dataset.galleryInit = '1';

      var mainEl  = gallery.querySelector('.product-gallery__main');
      var thumbEl = gallery.querySelector('.product-gallery__thumbnails');
      var prevBtn = gallery.querySelector('.product-gallery__nav-btn--prev');
      var nextBtn = gallery.querySelector('.product-gallery__nav-btn--next');

      if (!mainEl) return;

      // Thumbnail swiper (used as sync target for main swiper)
      var thumbSwiper = null;
      if (thumbEl) {
        thumbSwiper = new Swiper(thumbEl, {
          slidesPerView: 'auto',
          watchSlidesProgress: true,
          slideToClickedSlide: true,
          spaceBetween: 8,
        });
      }

      // Main image swiper
      var mainOptions = {
        loop: false,
        grabCursor: true,
        keyboard: { enabled: true, onlyInViewport: true },
      };

      if (prevBtn && nextBtn) {
        mainOptions.navigation = { prevEl: prevBtn, nextEl: nextBtn };
      }

      if (thumbSwiper) {
        mainOptions.thumbs = { swiper: thumbSwiper };
      }

      new Swiper(mainEl, mainOptions);
    });
  }

  // ─── PRODUCT PURCHASE OPTIONS (Selling Plans / Variants) ────────────────────

  function initProductOptions(root) {
    var scope = root || document;
    var forms = scope.querySelectorAll('.taik-product-form');

    forms.forEach(function (form) {
      if (form.dataset.optionsInit) return;
      form.dataset.optionsInit = '1';

      var sectionId = form.dataset.sectionId;
      var sellingPlanInput = form.querySelector('#SellingPlan-' + sectionId);
      var variantInput = form.querySelector('#VariantId-' + sectionId);
      var radios = form.querySelectorAll('.product-option__radio');

      var priceWrapper = document.getElementById('product-price-wrapper-' + sectionId);

      // Sync header price to whichever option is pre-checked on load
      var checkedRadio = form.querySelector('.product-option__radio:checked');
      if (checkedRadio) {
        var initPrice = checkedRadio.getAttribute('data-price');
        var initExternalUrl = checkedRadio.getAttribute('data-external-url');
        if (priceWrapper) {
          priceWrapper.style.display = initExternalUrl ? 'none' : '';
        }
        if (initPrice !== null && !initExternalUrl) {
          var initPriceEl = document.getElementById('product-price-' + sectionId);
          if (initPriceEl) {
            var initCents = parseInt(initPrice, 10);
            var initDollars = initCents / 100;
            initPriceEl.textContent = '$' + (initDollars % 1 === 0 ? initDollars.toFixed(0) : initDollars.toFixed(2));
          }
        }
        var initPlanId = checkedRadio.getAttribute('data-selling-plan');
        if (sellingPlanInput) sellingPlanInput.value = initPlanId || '';
      }

      radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!this.checked) return;

          var sellingPlanId = this.getAttribute('data-selling-plan');

          if (sellingPlanInput) {
            sellingPlanInput.value = sellingPlanId || '';
          }

          // Handle external redirect variants (e.g. Ebook)
          var externalUrl = this.getAttribute('data-external-url');

          // Update header price display when plan or variant changes
          if (priceWrapper) {
            priceWrapper.style.display = externalUrl ? 'none' : '';
          }
          var rawPrice = this.getAttribute('data-price');
          if (rawPrice !== null && !externalUrl) {
            var priceEl = document.getElementById('product-price-' + sectionId);
            if (priceEl) {
              var cents = parseInt(rawPrice, 10);
              var dollars = cents / 100;
              var formatted = '$' + (dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2));
              priceEl.textContent = formatted;
            }
          }

          if (variantInput && this.name === 'variant-id') {
            variantInput.value = this.value;
            if (typeof history !== 'undefined' && history.replaceState) {
              var url = new URL(window.location.href);
              url.searchParams.set('variant', this.value);
              history.replaceState({}, '', url.toString());
            }
          }
          var btn = form.querySelector('[name="add"]');
          if (btn) {
            if (externalUrl) {
              btn.setAttribute('data-redirect-url', externalUrl);
              btn.textContent = btn.getAttribute('data-external-text') || 'Buy Online';
            } else {
              btn.removeAttribute('data-redirect-url');
              btn.textContent = btn.getAttribute('data-default-text') || 'ADD TO CART';
            }
          }
        });
      });
    });
  }

  // ─── ADD TO CART (AJAX) ──────────────────────────────────────────────────────

  function initProductForm(root) {
    var scope = root || document;
    var forms = scope.querySelectorAll('.taik-product-form');

    forms.forEach(function (form) {
      if (form.dataset.formInit) return;
      form.dataset.formInit = '1';

      var submitBtn = form.querySelector('[name="add"]');

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        // External redirect variant (e.g. Ebook) — open URL in new tab instead of cart
        var redirectUrl = submitBtn && submitBtn.getAttribute('data-redirect-url');
        if (redirectUrl) {
          window.open(redirectUrl, '_blank');
          return;
        }

        var formData = new FormData(form);
        // Remove selling_plan if empty (one-time purchase)
        if (!formData.get('selling_plan')) {
          formData.delete('selling_plan');
        }

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Adding...';
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (data) {
                throw new Error(data.description || 'Could not add to cart.');
              });
            }
            return res.json();
          })
          .then(function () {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = submitBtn.getAttribute('data-atc-text') || 'ADD TO CART';
            }
            openCart();
          })
          .catch(function (err) {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = submitBtn.getAttribute('data-atc-text') || 'ADD TO CART';
            }
            var errorMsg = err.message || 'Sorry, something went wrong. Please try again.';
            var errorEl = form.querySelector('.taik-atc-error');
            if (!errorEl) {
              errorEl = document.createElement('p');
              errorEl.className = 'taik-atc-error';
              if (submitBtn) {
                submitBtn.insertAdjacentElement('afterend', errorEl);
              } else {
                form.appendChild(errorEl);
              }
            }
            errorEl.textContent = errorMsg;
            errorEl.style.display = 'block';
            setTimeout(function () {
              if (errorEl) errorEl.style.display = 'none';
            }, 5000);
          });
      });

      // Store original button text
      if (submitBtn) {
        submitBtn.setAttribute('data-atc-text', submitBtn.textContent.trim());
      }
    });
  }

  // ─── COLLECTION SORT ────────────────────────────────────────────────────────

  function initCollectionSort(root) {
    var scope = root || document;
    var sortForms = scope.querySelectorAll('[data-collection-sort]');

    sortForms.forEach(function (form) {
      if (form.dataset.sortInit) return;
      form.dataset.sortInit = '1';

      var select = form.querySelector('.taik-collection-grid__sort-select');
      if (!select) return;

      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        window.location.href = url.toString();
      });
    });
  }

  // ─── BLOG SIDEBAR TOGGLE ────────────────────────────────────────────────────

  function initBlogSidebar() {
    var toggle = document.getElementById('blogSidebarToggle');
    var panel = document.getElementById('blogSidebarPanel');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      panel.classList.toggle('blog-sidebar__panel--open');
    });
  }

  // ─── BLOG LOAD MORE ──────────────────────────────────────────────────────────

  function initBlogLoadMore() {
    var btn = document.getElementById('taik-load-more-btn');
    if (!btn) return;

    var originalHTML = btn.innerHTML;
    var MOBILE_BREAKPOINT = 1024;
    var MOBILE_INITIAL_GRID = 4; // 4 grid cards + 1 featured = 5 total on mobile
    var MOBILE_BATCH = 5;

    function isMobile() {
      return window.innerWidth < MOBILE_BREAKPOINT;
    }

    function hideExcessMobileCards() {
      if (!isMobile()) return;
      var cards = document.querySelectorAll('#taik-blog-grid .card');
      cards.forEach(function (card, i) {
        if (i >= MOBILE_INITIAL_GRID) {
          card.classList.add('card--load-more-hidden');
        }
      });
    }

    function revealNextMobileBatch() {
      var hidden = document.querySelectorAll('#taik-blog-grid .card--load-more-hidden');
      var toReveal = Array.from(hidden).slice(0, MOBILE_BATCH);
      toReveal.forEach(function (card) {
        card.classList.remove('card--load-more-hidden');
      });
      return hidden.length - toReveal.length; // remaining hidden count
    }

    btn.addEventListener('click', function () {
      var nextUrl = btn.dataset.nextUrl;

      // Mobile: reveal hidden cards first before fetching next page
      if (isMobile()) {
        var hidden = document.querySelectorAll('#taik-blog-grid .card--load-more-hidden');
        if (hidden.length > 0) {
          var remaining = revealNextMobileBatch();
          if (remaining === 0 && !nextUrl) {
            var wrapper = document.getElementById('taik-load-more-wrapper');
            if (wrapper) wrapper.style.display = 'none';
          }
          return;
        }
      }

      if (!nextUrl) return;

      btn.disabled = true;
      btn.innerHTML = 'LOADING&hellip;';

      fetch(nextUrl)
        .then(function (res) {
          if (!res.ok) throw new Error('Network error');
          return res.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          var newGrid = doc.getElementById('taik-blog-grid');
          var currentGrid = document.getElementById('taik-blog-grid');

          if (newGrid && currentGrid) {
            Array.from(newGrid.children).forEach(function (card, i) {
              var cloned = card.cloneNode(true);
              // On mobile, hide cards beyond the first batch in the fetched page
              if (isMobile() && i >= MOBILE_BATCH) {
                cloned.classList.add('card--load-more-hidden');
              }
              currentGrid.appendChild(cloned);
            });
          }

          var newBtn = doc.getElementById('taik-load-more-btn');
          if (newBtn && newBtn.dataset.nextUrl) {
            btn.dataset.nextUrl = newBtn.dataset.nextUrl;
            btn.disabled = false;
            btn.innerHTML = originalHTML;
          } else {
            btn.dataset.nextUrl = '';
            // Keep button visible if hidden cards still remain
            var stillHidden = document.querySelectorAll('#taik-blog-grid .card--load-more-hidden');
            if (stillHidden.length > 0) {
              btn.disabled = false;
              btn.innerHTML = originalHTML;
            } else {
              var wrapper = document.getElementById('taik-load-more-wrapper');
              if (wrapper) wrapper.style.display = 'none';
            }
          }
        })
        .catch(function () {
          btn.disabled = false;
          btn.innerHTML = originalHTML;
        });
    });

    function updateButtonVisibility() {
      var wrapper = document.getElementById('taik-load-more-wrapper');
      if (!wrapper) return;
      var hasHiddenCards = document.querySelectorAll('#taik-blog-grid .card--load-more-hidden').length > 0;
      var hasNextPage = !!btn.dataset.nextUrl;
      wrapper.style.display = (hasHiddenCards || hasNextPage) ? '' : 'none';
    }

    // Initialize: hide excess cards on mobile, then decide button visibility
    hideExcessMobileCards();
    updateButtonVisibility();

    // On resize: update hidden state and button when crossing the mobile breakpoint
    var resizeTimer;
    var wasAboveMobile = !isMobile();
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var isAboveMobile = !isMobile();
        if (isAboveMobile && !wasAboveMobile) {
          // Switched to desktop: reveal all hidden cards
          document.querySelectorAll('#taik-blog-grid .card--load-more-hidden').forEach(function (card) {
            card.classList.remove('card--load-more-hidden');
          });
        } else if (!isAboveMobile && wasAboveMobile) {
          // Switched to mobile: re-apply initial hiding
          hideExcessMobileCards();
        }
        wasAboveMobile = isAboveMobile;
        updateButtonVisibility();
      }, 150);
    });
  }

  // ─── BOOK TESTIMONIAL SLIDER ─────────────────────────────────────────────────

  function initTestimonialSlider(scope) {
    if (typeof Swiper === 'undefined') return;

    var containers = (scope || document).querySelectorAll('.testimonial-slider');
    containers.forEach(function (container) {
      var swiperEl = container.querySelector('.testimonial-slider__swiper');
      if (!swiperEl || swiperEl._swiperInstance) return;

      var prevBtn      = container.querySelector('.testimonial-slider__nav--prev');
      var nextBtn      = container.querySelector('.testimonial-slider__nav--next');
      var paginationEl = container.querySelector('.testimonial-slider__pagination');

      swiperEl._swiperInstance = new Swiper(swiperEl, {
        slidesPerView: 1,
        loop: true,
        speed: 400,
        grabCursor: true,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous testimonial',
          nextSlideMessage: 'Next testimonial',
          firstSlideMessage: 'This is the first testimonial',
          lastSlideMessage: 'This is the last testimonial',
        },
      });
    });
  }

  // ─── BOOK FORMAT SELECT ──────────────────────────────────────────────────────

  function initBookSelect(scope) {
    var selects = (scope || document).querySelectorAll('[data-book-select]');
    selects.forEach(function (select) {
      var wrapper = select.closest('[data-book-select-wrapper]');
      if (!wrapper) return;
      var nameEl   = wrapper.querySelector('.book-purchase__format-name');
      var priceEl  = wrapper.querySelector('.book-purchase__price');
      var form     = select.closest('form');
      var submitBtn = form && form.querySelector('[name="add"]');

      function syncDisplay() {
        var opt = select.options[select.selectedIndex];
        if (nameEl) nameEl.textContent = opt.text;
        var externalUrl = opt.getAttribute('data-external-url');
        if (priceEl) {
          if (externalUrl) {
            priceEl.style.display = 'none';
          } else {
            priceEl.style.display = '';
            var cents = parseInt(opt.dataset.price, 10);
            priceEl.textContent = '$' + (cents / 100).toFixed(2);
          }
        }
        if (submitBtn) {
          submitBtn.disabled = opt.disabled;
          if (opt.disabled) {
            submitBtn.textContent = 'SOLD OUT';
            submitBtn.removeAttribute('data-redirect-url');
          } else if (externalUrl) {
            submitBtn.setAttribute('data-redirect-url', externalUrl);
            submitBtn.textContent = 'Buy Online';
          } else {
            submitBtn.removeAttribute('data-redirect-url');
            submitBtn.textContent = 'ADD TO CART';
          }
        }
      }

      select.addEventListener('change', syncDisplay);
      syncDisplay();
    });
  }

  // ─── QUICK ADD TO CART ───────────────────────────────────────────────────────

  function initQuickAdd(scope) {
    var btns = (scope || document).querySelectorAll('[data-quick-add-variant]');
    btns.forEach(function (btn) {
      if (btn.dataset.quickAddInit) return;
      btn.dataset.quickAddInit = '1';

      btn.addEventListener('click', function (e) {
        e.preventDefault();

        var variantId = btn.getAttribute('data-quick-add-variant');
        if (!variantId) return;

        var originalText = btn.textContent.trim();
        btn.setAttribute('disabled', 'disabled');
        btn.querySelector('.button__icon') && (btn.querySelector('.button__icon').style.display = 'none');
        btn.firstChild.textContent = 'Adding... ';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (data) {
                throw new Error(data.description || 'Could not add to cart.');
              });
            }
            return res.json();
          })
          .then(function () {
            btn.removeAttribute('disabled');
            btn.firstChild.textContent = originalText + ' ';
            btn.querySelector('.button__icon') && (btn.querySelector('.button__icon').style.display = '');
            openCart();
          })
          .catch(function (err) {
            btn.removeAttribute('disabled');
            btn.firstChild.textContent = originalText + ' ';
            btn.querySelector('.button__icon') && (btn.querySelector('.button__icon').style.display = '');
            alert(err.message || 'Sorry, something went wrong. Please try again.');
          });
      });
    });
  }

  // ─── CART PAGE (full-page /cart) ─────────────────────────────────────────────

  function renderCartPage(cart) {
    var itemsList = document.getElementById('taik-cart-page-items');
    var totalEl   = document.getElementById('taik-cart-page-total');

    if (!itemsList) return;

    updateCartCount(cart.item_count);

    if (totalEl) {
      totalEl.textContent = formatMoney(cart.total_price);
    }

    var shippingBar = document.querySelector('.taik-cart-page .shipping-bar-wrapper');
    if (shippingBar) {
      shippingBar.innerHTML = cart.item_count > 0 ? buildShippingBarHTML(cart.total_price) : '';
    }

    if (cart.item_count === 0) {
      window.location.reload();
      return;
    }

    var html = '';
    cart.items.forEach(function (item, index) {
      var lineIndex = index + 1;
      var imgSrc = item.image ? item.image : '';
      var itemUrl = item.url || '';
      html += '<li class="cart-item cart-item--page">';
      html += '<a href="' + itemUrl + '" class="cart-item__image-link"><img class="cart-item__image" src="' + imgSrc + '" alt="' + (item.title || '').replace(/"/g, '&quot;') + '" width="121" loading="lazy"></a>';
      html += '<div class="cart-item__details">';
      html += '<button class="cart-item__button cart-item__button--remove" data-action="remove" data-line="' + lineIndex + '" aria-label="Remove from cart"><svg width="16" height="16" viewBox="0 0 16 16" fill="none"><line x1="4" y1="4" x2="12" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="12" y1="4" x2="4" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>';
      html += '<span class="cart-item__category">' + (item.product_type || '').toUpperCase() + '</span>';
      html += '<div class="cart-item__meta">';
      html += '<h2 class="cart-item__name"><a href="' + itemUrl + '" class="cart-item__name-link">' + (item.title || '') + '</a></h2>';
      html += '<span class="cart-item__price">' + formatMoney(item.line_price) + '</span>';
      html += '</div>';
      if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
        html += '<span class="cart-item__plan">' + item.selling_plan_allocation.selling_plan.name + '</span>';
      }
      if (item.properties) {
        Object.keys(item.properties).forEach(function (key) {
          var val = item.properties[key];
          if (key === 'Addressee' || !val || key.charAt(0) === '_') return;
          html += '<span class="cart-item__property"><strong>' + key + ':</strong> ' + val + '</span>';
        });
      }
      if (item.variant_title === 'Signed Hardcover') {
        var addresseeVal = (item.properties && item.properties['Addressee']) || '';
        html += '<div class="cart-item__addressee">';
        html += '<label class="cart-item__addressee-label" for="page-addressee-' + lineIndex + '">Sign to:</label>';
        html += '<input type="text" id="page-addressee-' + lineIndex + '" class="cart-item__addressee-input" data-line="' + lineIndex + '" value="' + addresseeVal.replace(/"/g, '&quot;') + '" placeholder="Enter a name (optional)" aria-label="Who should the book be signed to?">';
        html += '</div>';
      }
      html += '</div>';
      html += '<div class="cart-item__controls">';
      html += '<span class="cart-item__qty-label">QTY</span>';
      html += '<button class="cart-item__button" data-action="decrease" data-line="' + lineIndex + '" aria-label="Decrease quantity"><svg width="16" height="16" viewBox="0 0 16 16" fill="none"><line x1="4" y1="8" x2="12" y2="8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>';
      html += '<input type="number" class="cart-item__quantity" value="' + item.quantity + '" min="1" max="99" data-line="' + lineIndex + '" aria-label="Quantity">';
      html += '<button class="cart-item__button" data-action="increase" data-line="' + lineIndex + '" aria-label="Increase quantity"><svg width="16" height="16" viewBox="0 0 16 16" fill="none"><line x1="8" y1="4" x2="8" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="4" y1="8" x2="12" y2="8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>';
      html += '</div></li>';
    });

    itemsList.innerHTML = html;
    attachCartPageListeners();
  }

  function changeCartPageLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (res) {
      return res.json();
    }).then(function (cart) {
      renderCartPage(cart);
    });
  }

  function attachCartPageListeners() {
    var itemsList = document.getElementById('taik-cart-page-items');
    if (!itemsList) return;

    var buttons = itemsList.querySelectorAll('.cart-item__button');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = parseInt(btn.getAttribute('data-line'), 10);
        var action = btn.getAttribute('data-action');
        var input = itemsList.querySelector('.cart-item__quantity[data-line="' + line + '"]');
        var currentQty = input ? parseInt(input.value, 10) : 1;
        var newQty;
        if (action === 'remove') {
          newQty = 0;
        } else if (action === 'increase') {
          newQty = currentQty + 1;
        } else {
          newQty = Math.max(0, currentQty - 1);
        }
        changeCartPageLine(line, newQty);
      });
    });

    var quantityInputs = itemsList.querySelectorAll('.cart-item__quantity');
    quantityInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var line = parseInt(input.getAttribute('data-line'), 10);
        var newQty = Math.max(0, parseInt(input.value, 10) || 0);
        changeCartPageLine(line, newQty);
      });
    });

    var addresseeInputs = itemsList.querySelectorAll('.cart-item__addressee-input');
    addresseeInputs.forEach(function (input) {
      input.addEventListener('blur', function () {
        var line = parseInt(input.getAttribute('data-line'), 10);
        saveAddresseeProperty(line, input.value, renderCartPage);
      });
    });
  }

  function initCartPage() {
    var itemsList = document.getElementById('taik-cart-page-items');
    if (!itemsList) return;
    attachCartPageListeners();
  }

  // ─── STICKY HEADER SCROLL SHADOW ────────────────────────────────────────────

  function initStickyHeader() {
    var header = document.querySelector('.header');
    var headerGroup = document.getElementById('header-group');
    if (!header || !headerGroup) return;

    var hero = document.querySelector('.hero');

    if (!hero) {
      // No hero — become sticky once the top of #MainContent scrolls above the viewport
      var mainContent = document.getElementById('MainContent');
      if (!mainContent) return;

      function onScrollNoHero() {
        var scrolledPast = mainContent.getBoundingClientRect().top <= 0;
        headerGroup.classList.toggle('header-group--sticky', scrolledPast);
        header.classList.toggle('header--scrolled', scrolledPast);
      }
      window.addEventListener('scroll', onScrollNoHero, { passive: true });
      onScrollNoHero();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      var heroVisible = entries[0].isIntersecting;
      headerGroup.classList.toggle('header-group--sticky', !heroVisible);
      header.classList.toggle('header--scrolled', !heroVisible);
    }, { threshold: 0 });

    observer.observe(hero);
  }

  // ─── MEMBER BIO SHOW MORE ────────────────────────────────────────────────────

  function initMemberShowMore(scope) {
    var buttons = (scope || document).querySelectorAll('.member__show-more');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var extra = btn.closest('.member__meta-wrap').querySelector('.member__bio-extra');
        var expanded = extra.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', String(expanded));
        btn.textContent = expanded ? 'Read less' : 'Read more';
      });
    });
  }

  // ─── RE-INIT ─────────────────────────────────────────────────────────────────

  function init(scope) {
    initAnnouncementBar();
    initStickyHeader();
    initMobileMenu();
    initDropdowns();
    initCart();
    initCartPage();
    initAccordions(scope);
    initProductGallery(scope);
    initProductOptions(scope);
    initProductForm(scope);
    initCollectionSort(scope);
    initBlogSidebar();
    initBlogLoadMore();
    initTestimonialSlider(scope);
    initBookSelect(scope);
    initQuickAdd(scope);
    initMemberShowMore(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

})();
